import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { BaseMiscApiService } from '@common/api/base-misc-api.service';

@Injectable({
    providedIn: 'root'
})
export class FiltersApiService extends BaseMiscApiService
{
    constructor (
        http: HttpClient
    )
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlPrtg;
        this.segmentApi = '/prtg/filters';
    }

    getFilters (): Observable<string[]>
    {
        return this.get();
    }
}
